export const ONE_MILE_TO_METER = 1609.34

export function milesToMeter(miles: number): number {
  return miles * ONE_MILE_TO_METER
}
